export default __webpack_public_path__ + "20a8247a982e706158a0858b90f22b9d.png";